<template>
  <div
    ref="container"
    class="tw:flex tw:flex-1 tw:overflow-hidden"
  >
    <div
      class="tw:whitespace-nowrap"
      :class="{ 'tw:flex-1 tw:overflow-hidden tw:text-ellipsis': showMore }"
    >
      <span
        v-for="(topic, topicIndex) in topics"
        :key="topic.id"
      >
        <template v-if="topicIndex">,</template>
        {{ topic.name }}
      </span>
    </div>
    <div
      v-if="showMore"
      class="tw:shrink-0 tw:cursor-pointer tw:pl-1 tw:text-blue-700 tw:hover:text-blue-500"
    >
      {{
        getLocaleText("source_list_topics.see_all", {
          totalTopics: topics.length,
        })
      }}

      <StreemTooltip
        anchor="bottom middle"
        self="top end"
      >
        <div class="tw:flex tw:flex-col tw:gap-2 tw:p-2 tw:text-sm">
          <div class="tw:font-bold">
            {{ getLocaleText("source_list_topics.sectors") }}
          </div>
          <div>
            <span
              v-for="(topic, topicIndex) in topics"
              :key="topic.id"
            >
              <template v-if="topicIndex">,</template>
              {{ topic.name }}
            </span>
          </div>
        </div>
      </StreemTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import StreemTooltip from "shared/components/base/StreemTooltip.vue";

interface Topic {
  id: number;
  name: string;
}

interface Props {
  topics: Topic[];
}

withDefaults(defineProps<Props>(), {
  topics: () => [],
});

const container = ref<HTMLDivElement>();

const showMore = computed(() => {
  if (!container.value) return false;

  return container.value.offsetWidth < container.value.scrollWidth;
});
</script>
